import React from "react";
import Header from "../../components/header";
import Navbar from "../../components/navbar";
import Footer from "../../components/footer";
import Banner from "../../images/leistungen/bg_hand_herz.png";
import Ekg from "../../images/leistungen/ekg.jpg";

const Leistungen = () => {
    return (
        <main>
            <Header image={Banner} />
            <section className="content-section">
                <Navbar />

                <div className="page-container">
                    <h1>Leistung</h1>
                    <img src={Ekg} style={{ float: "right" }} alt="EKG" />
                    <ol>
                        <li><a href="/homepage/#/leistungen/ekg"><strong>EKG</strong></a></li>
                        <li><a href="/homepage/#/leistungen/ergometrie"><strong>Ergometrie</strong></a></li>
                        <li><a href="/homepage/#/leistungen/echokardiographie"><strong>Echokardiographie-Herzultraschall</strong></a></li>
                        <li><a href="/homepage/#/leistungen/carotis"><strong>Carotis Ultraschall</strong></a></li>
                        <li><a href="/homepage/#/leistungen/schilddruese"><strong>Schilddrüsenuntersuchung</strong></a></li>
                        <li><a href="/homepage/#/leistungen/opf"><strong>OP Freigabe</strong></a></li>
                        <li><a href="/homepage/#/leistungen/schrittmacher"><strong>Schrittmacherkontrolle - NEU</strong></a></li>
                        <li><a href="/homepage/#/leistungen/patientenverfuegung"><strong>Medizinisches Patientenverfügungs-Beratungsgespräch</strong></a></li>
                        <li><a href="/homepage/#/leistungen/raucherentwoehnung"><strong>Raucherentwöhnung</strong></a></li>
                        <li><a href="/homepage/#/leistungen/24stunden_ekg"><strong>24 Stunden EKG</strong></a></li>
                        <li><a href="/homepage/#/leistungen/24stunden_blutmessung"><strong>24-Stunden Blutdruckmessung, auch ABDM oder Langzeitblutdruck</strong></a></li>
                        <li><a href="/homepage/#/leistungen/herzinsuffizienz"><strong>Herzinsuffizienztherapieoptimierung</strong></a></li>
                        <li><a href="/homepage/#/leistungen/vorsorge"><strong>Vorsorgeuntersuchung</strong></a></li>
                        <li><a href="/homepage/#/leistungen/tauchen"><strong>Tauchtauglichkeitsuntersuchungen, ÖGTH</strong></a></li>
                        <li><a href="/homepage/#/leistungen/diabetes"><strong>Diabetes im Griff</strong></a></li>
                        <li><a href="/homepage/#/leistungen/impfen"><strong>Impfberatung</strong></a></li>
                    </ol>
                </div>
            </section>
            <Footer />
        </main>
    );
};

export default Leistungen;
